import Config from '@/shared/config/config'
import {
    getLocalConfig,
    saveLocalConfig,
    clearConfig,
} from '@/shared/config/db/configDb'
import { getErrorMessage } from '@/shared/lib'
import { getConfigService } from '@/shared/getContainer/getConfigService'

const getApiConfig = await getConfigService()

export class ConfigRepositoryStreamIQ {
    lastUpdateConfigFailTime = 0
    updateConfigFailAttempts = 0
    private static _instance: ConfigRepositoryStreamIQ

    public static get Instance() {
        return (this._instance = new ConfigRepositoryStreamIQ())
    }
    getLocalConfig = (): Config | null | undefined => {
        const jsonLocalConfig = getLocalConfig()
        if (jsonLocalConfig) {
            try {
                const configObj = new Config(jsonLocalConfig)
                return configObj
            } catch (error) {
                getErrorMessage('getLocalConfig', error)
                throw error
            }
        }
    }

    getRemoteConfig = async (): Promise<Config | null | undefined> => {
        try {
            const remoteConfig = await getApiConfig()

            if (remoteConfig) {
                remoteConfig.getConfigSaveTime()
                return remoteConfig
            } else {
                //start measure time since last update config fail
                this.updateConfigFailAttempts += 1
                // actual time in seconds
                this.lastUpdateConfigFailTime = Math.floor(Date.now() / 1000)
            }
            return null
        } catch (error) {
            getErrorMessage('getRemoteConfig', error)
            throw error
        }
    }

    takeConfigIfNeed = async (): Promise<void | Config> => {
        //check if config is in LS and get it if it is not
        const localConfig = this.getLocalConfig()

        if (!localConfig?.configVersion) {
            try {
                const remoteConfig = await this.getRemoteConfig()
                if (remoteConfig) {
                    saveLocalConfig(remoteConfig)
                    return remoteConfig
                }
            } catch (error) {
                getErrorMessage('takeConfigIfNeed', error)
                throw error
            }
        }
    }

    checkConfigAndUpdateIfNeed = async (): Promise<boolean> => {
        const localConfig = this.getLocalConfig()

        if (localConfig) {
            saveLocalConfig(localConfig)
        } else {
            try {
                const remoteConfig = await this.getRemoteConfig()
                console.log('remoteConfig', remoteConfig)
                if (remoteConfig) {
                    saveLocalConfig(remoteConfig)
                    return true
                }
            } catch (error) {
                getErrorMessage('checkConfigAndUpdateIfNeed', error)
                throw error
            }
        }
        return false
    }

    handleUpdateConfigFail = (): void => {
        const localConfig = this.getLocalConfig()

        if (localConfig) {
            // check if maximum number of update config attempts exceeded
            if (
                this.updateConfigFailAttempts >=
                localConfig.tvUpdateIntervals.configUpdateMaxRetries
            ) {
                // maximum number of update config attempts exceeded
                this.lastUpdateConfigFailTime =
                    localConfig.tvUpdateIntervals.configUpdateIntervalOnSuccess
                this.updateConfigFailAttempts = 0
            }
            //update time since last update config fail
            const secondsSinceLastGetConfigFail =
                Math.floor(Date.now() / 1000) - this.lastUpdateConfigFailTime

            if (
                secondsSinceLastGetConfigFail >
                localConfig.tvUpdateIntervals.configUpdateIntervalOnError
            ) {
                //reset lastGetConfigFailTime to retake get config attempt
                this.lastUpdateConfigFailTime = 0
            }
        }
    }

    removeConfig = (): boolean => {
        try {
            const localConfig = this.getLocalConfig()
            if (localConfig) {
                clearConfig() // Function to remove local config
                this.lastUpdateConfigFailTime = 0 // Reset state if needed
                this.updateConfigFailAttempts = 0 // Reset failure attempts
                return true
            } else {
                console.warn('No local configuration found to remove.')
                return false
            }
        } catch (error) {
            getErrorMessage('removeConfig', error)
            throw error
        }
    }
}
